import ApplicationController from "./application_controller"

// Plain native file-input upload - no crop tool, click selects a file and previews it
// directly in this same modal screen.
export default class extends ApplicationController {
  static targets = ["preview", "input", "saveButton", "filename", "placeholder"]
  static values = { uploadUrl: String }

  openPicker(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    this.previewTarget.src = URL.createObjectURL(file)
    this.previewTarget.style.display = "block"
    if (this.hasPlaceholderTarget) this.placeholderTarget.style.display = "none"
    if (this.hasFilenameTarget) this.filenameTarget.textContent = file.name
    this.saveButtonTarget.disabled = false
  }

  save(event) {
    event.preventDefault()
    const file = this.inputTarget.files[0]
    if (!file) {
      alert("Please select an image first.")
      return
    }

    const formData = new FormData()
    formData.append("image[image]", file)

    this.saveButtonTarget.disabled = true
    fetch(this.uploadUrlValue, {
      method: "POST",
      headers: { "X-CSRF-Token": this.csrfToken, "Accept": "application/json" },
      body: formData
    })
      .then(response => {
        if (!response.ok) throw new Error(`HTTP Error: ${response.status}`)
        window.location.reload()
      })
      .catch(error => {
        console.error("Error uploading image:", error)
        alert("Upload failed. Please try again.")
        this.saveButtonTarget.disabled = false
      })
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta ? meta.content : ""
  }
}
